<template>
  <div>
    <section class="section">
      <div class="level is-mobile">
        <div class="level-left"></div>
        <div class="level-right">
          <div class="level-item">
            <b-button
              class="button is-primary is-medium"
              @click="isCategoryModalActive = true"
            >
              {{ $t("button.addCategory") }}
            </b-button>
          </div>
        </div>
      </div>
      <categories-table
        :loading="loading"
        :categories="categoriesForTable"
      ></categories-table>
    </section>
    <category-modal
      :isCategoryModalActive="isCategoryModalActive"
      @close="isCategoryModalActive = false"
    ></category-modal>
  </div>
</template>

<script>
import CategoriesTable from "@/components/tables/CategoriesTable.vue";
const CategoryModal = () => import("@/components/modals/CategoryModal.vue");
import { mapGetters } from "vuex";

export default {
  components: {
    CategoriesTable,
    CategoryModal,
  },
  data() {
    return {
      loading: false,
      isCategoryModalActive: false,
    };
  },
  created() {
    this.getCategories();
  },
  methods: {
    getCategories() {
      this.loading = true;
      // TODO move to transactionModal
      this.$store
        .dispatch("categories/getCategories")
        .then(() => (this.loading = false));
      // .then(this.showValidTransactionEdit);
    },
  },
  computed: {
    ...mapGetters("categories", ["categoriesIncome", "categoriesExpense"]),
    categoriesForTable() {
      let categoriesIncome = [...this.categoriesIncome].map((category) => {
        return { ...category, type: "income" };
      });
      let categoriesExpense = [...this.categoriesExpense].map((category) => {
        return { ...category, type: "expense" };
      });

      return [...categoriesIncome, ...categoriesExpense];
    },
  },
};
</script>
